import ErrorInput from "../ui/ErrorInput";
import PropTypes from "prop-types";

export const InputSelect = ({ label, subObjeto, arrData, formik }) => {

  return (
    <>
      <label htmlFor="">{label}</label>
      <select
        name={`${subObjeto[0]}.${subObjeto[1]}`}
        className="form-select"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[subObjeto[0]][subObjeto[1]]}
      >
        <option value="">Seleccione</option>
        {arrData?.map((el) => <option value={el.value} key={el.value}>{el.label}</option>)}
      </select>
      {formik.errors[subObjeto[0]] !== undefined &&
        formik.touched[subObjeto[0]] !== undefined && (
          <ErrorInput
            touched={formik.touched[subObjeto[0]][subObjeto[1]]}
            error={formik.errors[subObjeto[0]][subObjeto[1]]}
          />
        )}
    </>
  )
}

InputSelect.propTypes = {
  label: PropTypes.string.isRequired,
  subObjeto: PropTypes.arrayOf(PropTypes.string).isRequired,
  arrData: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  formik: PropTypes.shape({
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
  }).isRequired,
};